import { DOCUMENT_LANG } from 'js/core/constants';
import { registerLocale } from 'react-datepicker';
import { nl, fr, de } from 'date-fns/locale';

registerLocale('nl', nl);
registerLocale('fr', fr);
registerLocale('de', de);

export const getJsLocale = () => DOCUMENT_LANG.replace('_', '-');

export const getDatePickerLocale = () => {
    const lang = DOCUMENT_LANG.split('_')[0];
    return ['nl', 'fr', 'de'].includes(lang) ? lang : 'nl';
};
